<template>
  <div id="leads" class="d-flex align-items-center min-vh-100">
    <CContainer fluid>
      <element-loading :active="loadingIn">
        <img src="img/loading_latino.gif" width="75px" height="75px" />
      </element-loading>
      <CRow class="justify-content-center">
        <CCol md="12">
          <CCard class="mx-4 mb-0">
            <CCardBody class="p-4">
              <CForm id="formPer" @submit.prevent="enviar">
                <CRow>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Nombre<span class="text-danger">*</span>
                      </label>
                      <input type="text" class="form-control" placeholder="Nombre" autocomplete="Nombre"
                        v-model="personas.nombre" required v-on:blur="handleString" />
                      <small class="text-danger input__error__message" >No puede haber números</small >
                      <!-- </CInput> -->
                    </div>
                  </CCol>

                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Apellido Paterno<span class="text-danger">*</span>
                      </label>
                      <input
                        class="form-control"
                        placeholder="Apellido Paterno"
                        autocomplete="Apellido Paterno"
                        v-model="personas.apellidoP"
                        required
                        v-on:blur="handleString"
                      />
                      <small class="text-danger input__error__message"
                        >No puede haber números</small
                      >

                      <!-- </CInput> -->
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Apellido Materno<span class="text-danger">*</span>
                      </label>
                      <input
                        placeholder="Apellido Materno"
                        autocomplete="Apellido Materno"
                        v-model="personas.apellidoM"
                        required
                        v-on:blur="handleString"
                        class="form-control"
                      />
                      <small class="text-danger input__error__message"
                        >No puede haber números</small
                      >
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="4">
                    <div class="form-group mb-0">
                      <label for=""
                        >Fecha de nacimiento <span class="text-danger">*</span>
                      </label>
                      <div class="d-flex align-items-start">
                        <CInput id="cDia" type="number" style="width: 100px" placeholder="DD" min="01"
                          max="31"  v-model="personas.dd" @keyup="handleDay" required class="mb-0" />
                        <div class="text-dark pl-1 pr-1" style="font-size: 20px">
                          /
                        </div>
                        <CInput id="cMes" type="number" style="width: 100px" placeholder="MM"
                          min="01" max="12" v-model="personas.mm" @keyup="handleMonth"
                          required class="text-center" />

                        <div class="text-dark pl-1 pr-1" style="font-size: 20px">
                          /
                        </div>
                        <CInput id="cAno" type="number" style="width: 150px" placeholder="AAAA"
                          min="1900" max="2500" v-model="personas.aa" v-on:blur="handleYear"
                          required class="mb-0" />
                      </div>
                      <small class="text-danger d-block mb-1" v-if="dateError">Formato de fecha no válida</small>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Correo electrónico <span class="text-danger">*</span>
                      </label>
                      <input
                        class="form-control validate_email"
                        placeholder="Correo Electronico"
                        autocomplete="email"
                        v-model="personas.email"
                        required
                        type="email"
                        v-on:blur="handleEmail"
                      />
                      <small class="text-danger input__error__message"
                        >El email no es válido</small
                      >
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Número de teléfono <span class="text-danger">*</span>
                      </label>
                      <input type="number" placeholder="Numero de Telefono" autocomplete="Telefono"
                        maxlength="10" minlength="10" v-model="personas.telefono" @change="changeCell"
                        v-on:blur="handlePhone" required class="form-control validate_phone"/>
                      <small class="input__error__message text-danger" v-if="sendError">Este número no es válido</small>
                    </div>
                  </CCol>
                </CRow>
                <CRow>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Estado <span class="text-danger">*</span>
                      </label>
                      <CSelect
                        vertical
                        id="cbxEstado"
                        :options="catEstados"
                        placeholder="Estado"
                        required
                        v-model="personas.estado"
                        :value.sync="personas.estado"
                      >
                        <!-- <template #prepend-content
                          ><CIcon name="cil-location-pin"
                        /></template> -->
                      </CSelect>
                    </div>
                  </CCol>
                  <CCol md="4">
                    <div class="form-group">
                      <label for=""
                        >Seguro de interés <span class="text-danger">*</span>
                      </label>
                      <CSelect
                        vertical
                        :options="catProductos"
                        placeholder="Seguro de tu interes.."
                        required
                        v-model="personas.producto"
                        :value.sync="personas.producto"
                      >
                        <!--  <template #prepend-content
                          ><CIcon name="cil-list"
                        /></template> -->
                      </CSelect>
                    </div>
                  </CCol>
                </CRow>
                <div
                  class="d-flex align-items-center justify-content-center"
                  style="height: 40px"
                >
                  <input
                    type="checkbox"
                    id="checkAvisoPrivacidad"
                    v-model="checkAvisoPrivacidad"
                    class="mr-2"
                    style="height: 20px; width: 20px"
                  />
                  <span>
                    <label for="checkAvisoPrivacidad" class="pt-1">
                      He leído y acepto el
                    </label>
                    <span
                      @click="loadAvisoPrivacidad"
                      class="cursor-pointer"
                      style="text-decoration: underline"
                      > aviso de privacidad
                    </span>
                  </span>
                </div>

                <CRow align-horizontal="center">
                  <CAlert
                    :color="alertColor"
                    closeButton
                    :show.sync="alertTrue"
                  >
                    {{ messageAlert }}
                  </CAlert>
                  <vue-recaptcha
                    sitekey="6Le6KAwcAAAAAHxMleQ5SVIUZ0jLIU2yzhahk8zM"
                  ></vue-recaptcha>
                </CRow>
                <CRow align-horizontal="center">
                  <div class="form-group pt-3 pb-3">
                    <CButton
                      class="pt-2 pb-2 pl-5 pr-5"
                      color="primary--custom"
                      shape="pill"
                      type="submit"
                      :disabled="!checkAvisoPrivacidad"
                      >Enviar</CButton
                    >
                  </div>
                </CRow>
              </CForm>
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
    <CModal title="Aviso de privacidad" size="lg" :show.sync="modalAvisoPrivacidad">
      <template #footer-wrapper><span></span></template>
      <CRow>
        <CCol col="12">
          <CCardBody class="p-0">
            <element-loading :active="loadingAvisoPrivacidad">
              <img src="img/loading_latino.gif" width="75px" height="75px" />
            </element-loading>

            <iframe
              src="https://servintd.latinoseguros.com.mx/ovl/archivos/aviso_privacidad_integral.pdf"
              frameborder="0"
              class="w-100"
              style="min-height: calc(100vh - 250px)"
              v-if="showAvisoPrivacidad"
            ></iframe>
          </CCardBody>
          <CCardFooter align="right">
            <CButton
              @click="modalAvisoPrivacidad = false"
              color="outline-secondary"
            >
              Cerrar
            </CButton>
          </CCardFooter>
        </CCol>
      </CRow>

      <template><span></span></template>
    </CModal>
  </div>
</template>

<script>
import VueRecaptcha from "../../../node_modules/vue-recaptcha";
import { form, validate } from "../../assets/helpers";

import { axiosBaseUrl } from "../../store/actions/ModuloActions";

export default {
  components: {
    VueRecaptcha,
  },
  name: "LeadPer",
  data() {
    return {
      checkAvisoPrivacidad: false,
      modalAvisoPrivacidad: false,
      loadingAvisoPrivacidad: false,
      showAvisoPrivacidad: false,

      catEstados: [],
      catProductos: [],
      catProductosEmp: [],
      alertColor: "",
      messageAlert: "",
      alertTrue: false,
      sendError: false,
      tipo: "",
      personas: {
        nombre: "",
        apellidoP: "",
        apellidoM: "",
        email: "",
        telefono: "",
        producto: 0,
        estado: 0,
        fnacimiento: "",
        dd: "",
        mm: "",
        aa: "",
      },
      bValida: 0,
      flag: false,
      loadingIn: false,
      respuesta: [],
      dateError: false,
    };
  },
  methods: {
    register() {
      this.$router.push({ path: "/dashboard" });
    },
    loadAvisoPrivacidad() {
      this.modalAvisoPrivacidad = true;
      this.showAvisoPrivacidad = true;
    },
    changeCell(){
      if(this.personas.telefono.length < 10 || this.personas.telefono.length > 10){
        this.sendError = true
      }
    },
    async enviar(e) {
      const button = e.target.querySelector("[type='submit']");
      button.setAttribute("disabled", true);

      if(this.personas.dd.length < 2 || this.personas.mm.length < 2 || this.personas.aa.length < 4){
        this.dateError = true
        this.checkAvisoPrivacidad = false;
      } else if(this.personas.telefono.length < 10 || this.personas.telefono.length > 10){
        this.sendError = true
        this.checkAvisoPrivacidad = false;
      }
      else {

        const payloadLead = {
          metodo: "SRVLEADS",
          data: {
            Nombre: this.personas.nombre,
            APaterno: this.personas.apellidoP,
            AMaterno: this.personas.apellidoM,
            Telefono: this.personas.telefono,
            email: this.personas.email,
            idCatTipoPersona: "1",
            idFormulario: "1",
            claveEstado: this.personas.estado,
            NombreEstado: $('select[id="cbxEstado"] option:selected').text(),
            NombreEmpresa: "",
            idCatProducto: this.personas.producto,
            FechaNacimiento:
              this.personas.dd + "/" + this.personas.mm + "/" + this.personas.aa,
          },
        };
  
        this.loadingIn = true;
        const res = await this.$store.dispatch("metodoPost", payloadLead);
        const response = this.$store.getters.getRespuestaREST;
        if (res) {
          this.messageAlert = `Recibimos su solicitud, en breve uno de nuestros agentes se pondra en contacto con usted.`;
          this.alertColor = "success";
        } else {
          this.alertColor = "danger";
          this.messageAlert = "Algo salio mal, por favor intente mas tarde!!";
        }
  
        this.loadingIn = false;
        this.alertTrue = true;
        button.removeAttribute("disabled");
        this.checkAvisoPrivacidad = false;
        grecaptcha.reset()
  
        // Clean
        this.personas.nombre = "";
        this.personas.apellidoP = "";
        this.personas.apellidoM = "";
        this.personas.telefono = "";
        this.personas.email = "";
        this.personas.estado = "";
        this.personas.producto = "";
        this.personas.dd = "";
        this.personas.mm = "";
        this.personas.aa = "";
        $('select[id="cbxEstado"]').val("");
      }

    },
    Limpia() {
      var config = {
        metodo: "GETEMPLEADO",
        data: "IdEmpleado=650",
      };

      this.$store.dispatch("metodoPost", config).then(() => {
        this.respuesta = this.$store.getters.getRespuestaREST;
      });

      console.log(this.respuesta);
    },
    handleDay(e) {
      if (validate.date.day(e.target.value)) {
        e.target.classList.remove("input__error");
        this.dateError = false;
      } else {
        e.target.classList.add("input__error");
        this.dateError = true;
        return;
      }

      if (e.target.value.length == 2) {
        document.querySelector("#cMes").focus();
      }
    },
    handleMonth(e) {
      if (validate.date.month(e.target.value)) {
        e.target.classList.remove("input__error");
        this.dateError = false;
      } else {
        e.target.classList.add("input__error");
        this.dateError = true;
        return;
      }

      if (e.target.value.length == 2) {
        document.querySelector("#cAno").focus();
      }
    },
    handleYear(e) {
      if (validate.date.year(e.target.value)) {
        e.target.classList.remove("input__error");
        this.dateError = false;
      } else {
        e.target.classList.add("input__error");
        this.dateError = true;
      }
    },
    handleEmail(e) {
      const message = e.target.parentElement.querySelector(
        ".input__error__message"
      );

      if (validate.email(e.target.value)) {
        e.target.classList.remove("input__error");
        message.style.display = "none";
      } else {
        e.target.classList.add("input__error");
        message.style.display = "block";
      }
    },
    handlePhone(e) {
      const message = e.target.parentElement.querySelector(
        ".input__error__message"
      );
      if (validate.phone(e.target.value)) {
        e.target.classList.remove("input__error");
        message.style.display = "none";
      } else {
        e.target.classList.add("input__error");
        message.style.display = "block";
      }
    },
    handleString(e) {
      const message = e.target.parentElement.querySelector(
        ".input__error__message"
      );

      if (!validate.string(e.target.value)) {
        message.style.display = "block";
        e.target.classList.add("input__error");
      } else {
        message.style.display = "none";
        e.target.classList.remove("input__error");
      }
    },
  },
  mounted() {
    this.catEstados = [
      { value: "01", label: "Aguascalientes" },
      { value: "02", label: "Baja California" },
      { value: "03", label: "Baja California Sur" },
      { value: "04", label: "Campeche" },
      { value: "07", label: "Chiapas" },
      { value: "08", label: "Chihuahua" },
      { value: "09", label: "CDMX" },
      { value: "05", label: "Coahuila" },
      { value: "06", label: "Colima" },
      { value: "10", label: "Durango" },
      { value: "15", label: "Estado de México" },
      { value: "11", label: "Guanajuato" },
      { value: "12", label: "Guerrero" },
      { value: "13", label: "Hidalgo" },
      { value: "14", label: "Jalisco" },
      { value: "16", label: "Michoacán" },
      { value: "17", label: "Morelos" },
      { value: "18", label: "Nayarit" },
      { value: "19", label: "Nuevo León" },
      { value: "20", label: "Oaxaca" },
      { value: "21", label: "Puebla" },
      { value: "22", label: "Querétaro" },
      { value: "23", label: "Quintana Roo" },
      { value: "24", label: "San Luis Potosí" },
      { value: "25", label: "Sinaloa" },
      { value: "26", label: "Sonora" },
      { value: "27", label: "Tabasco" },
      { value: "28", label: "Tamaulipas" },
      { value: "29", label: "Tlaxcala" },
      { value: "30", label: "Veracruz" },
      { value: "31", label: "Yucatan" },
      { value: "32", label: "Zacatecas" },
    ];
    this.catProductos = [
      { value: 98, label: "Seguro de Accidentes" },
      { value: 99, label: "Seguro de Gastos Médicos Mayores" },
      { value: 100, label: "Seguro de Vida" },
      { value: 101, label: "Seguro de Auto o Pickup" },
      { value: 102, label: "Seguro de Auto Clásico" },
      { value: 103, label: "Seguro de Camión" },
      { value: 104, label: "Seguro de Motocicleta" },
      { value: 105, label: "Seguro de Daños Hogar" },
      { value: 106, label: "Seguro Empresarial" },
    ];

    this.catProductosEmp = [
      { value: 98, label: "Seguro de Accidentes" },
      { value: 99, label: "Seguro de Gastos Médicos Mayores" },
      { value: 100, label: "Seguro de Vida" },
      { value: 107, label: "Seguro de Flotilla" },
      { value: 106, label: "Seguro Empresarial" },
    ];

    // Token anónimo
    const usuario = {
      password: "Latino2021*",
      userName: "userApiLeads",
    };
    this.$store.dispatch("login", { usuario, redir: true }).then(() => {});
  },
};
</script>
